import Arrow from './Arrow';
import Badge from './Badge';
import Color from './Color';
import Default from './Default';
import Heat from './Heat';
import Image from './Image';
import Progress from './Progress';
import Redirect from './Redirect';
import StatusVisit from './StatusVisit';
import Symbol from './Symbol';

export default {
  Default,
  Badge,
  Color,
  Heat,
  Progress,
  StatusVisit,
  Arrow,
  Image,
  Redirect,
  Symbol,
};
